import { SctFormValidation } from './_SctFormValidation';
var __ = wp.i18n.__;
var SctApiCheck = /** @class */ (function () {
    function SctApiCheck() {
        var _this = this;
        var getApiInputSlack = (document.getElementById('slack_webhook_url'));
        var getApiInputDiscord = (document.getElementById('discord_webhook_url'));
        getApiInputSlack.addEventListener('change', function (e) {
            var eventValue = e.target;
            _this.callValidation(eventValue);
        }, false);
        getApiInputDiscord.addEventListener('change', function (e) {
            var eventValue = e.target;
            _this.callValidation(eventValue);
        }, false);
    }
    SctApiCheck.prototype.callValidation = function (eventValue) {
        var tool;
        var notifyHtmlClass;
        if ('slack_webhook_url' === eventValue.id) {
            tool = 'slack';
            notifyHtmlClass = (document.getElementById('slack-check'));
        }
        else if ('discord_webhook_url' === eventValue.id) {
            tool = 'discord';
            notifyHtmlClass = (document.getElementById('discord-check'));
        }
        else {
            tool = 'teams';
            notifyHtmlClass = (document.getElementById('teams-check'));
        }
        var validation = new SctFormValidation(eventValue.value);
        if (validation.urlCheck(tool)) {
            this.createContent(eventValue);
        }
        else {
            notifyHtmlClass.classList.remove('connect-true');
            notifyHtmlClass.classList.add('connect-false');
            var msg = __('Not an appropriate value.', 'send-chat-tools');
            notifyHtmlClass.innerHTML = msg;
        }
    };
    SctApiCheck.prototype.createContent = function (eventValue) {
        var textArea;
        var url;
        var options;
        if ('slack_webhook_url' === eventValue.id) {
            textArea = document.getElementById('slack-check');
            url = eventValue.value;
            options = {
                method: 'POST',
                body: JSON.stringify({
                    text: 'Test message from Send Chat Tools.',
                }),
            };
        }
        else if ('discord_webhook_url' === eventValue.id) {
            textArea = document.getElementById('discord-check');
            url = eventValue.value;
            options = {
                method: 'POST',
                headers: {
                    'content-Type': 'application/json;charset=utf-8',
                },
                body: JSON.stringify({
                    content: 'Test message from Send Chat Tools.',
                }),
            };
        }
        else {
            textArea = document.getElementById('-check');
            url = eventValue.value;
            options = {
                method: 'POST',
                headers: {},
                body: '',
            };
        }
        this.send(options, textArea, url);
    };
    SctApiCheck.prototype.send = function (options, textArea, url) {
        fetch(url, options)
            .then(function (res) {
            var jsons = res;
            var responsOk = jsons.ok;
            if (responsOk) {
                textArea.classList.remove('connect-false');
                textArea.classList.add('connect-true');
                var msg = __('Sent a test message.', 'send-chat-tools');
                textArea.innerHTML = msg;
            }
            else {
                textArea.classList.remove('connect-true');
                textArea.classList.add('connect-false');
                textArea.innerHTML = __('Could not connect.', 'send-chat-tools');
            }
        })
            .catch(function (error) {
            if ('Failed to fetch' === error.message) {
                textArea.classList.remove('connect-true');
                textArea.classList.add('connect-false');
                textArea.innerHTML = __('Could not connect.', 'send-chat-tools');
            }
        });
    };
    return SctApiCheck;
}());
export { SctApiCheck };
